const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getAlerts(orgId, filters = {}) {
  const params = new URLSearchParams();
  
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.assetId) params.append('assetId', filters.assetId);
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.severity) params.append('severity', filters.severity);
  if (filters.type) params.append('type', filters.type);
  if (filters.acknowledged !== undefined) params.append('acknowledged', filters.acknowledged);
  if (filters.limit) params.append('limit', filters.limit);
  if (filters.offset) params.append('offset', filters.offset);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/alerts${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view alerts');
    }
    throw new Error('Failed to fetch alerts');
  }
  
  return response.json();
}

export async function getAlert(orgId, alertId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/alerts/${alertId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Alert not found');
    }
    if (response.status === 403) {
      throw new Error('You do not have permission to view this alert');
    }
    throw new Error('Failed to fetch alert');
  }
  
  const data = await response.json();
  return data.alert;
}

export async function acknowledgeAlert(orgId, alertId, notes = null) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/alerts/${alertId}/ack`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ notes })
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Alert not found');
    }
    if (response.status === 403) {
      throw new Error('You do not have permission to acknowledge alerts');
    }
    throw new Error('Failed to acknowledge alert');
  }
  
  const data = await response.json();
  return data.alert;
}
